import { useState } from "react";
import { AppSettingsVar } from "../../../_project/settings";
import useButtonActions from "../../../hooks/use-button-actions";
import i18n from "../../../i18n";

const CheckboxCards = ({
    fieldName, 
    label, 
    options, 
    helpText, 
    required, 
    value, 
    placeholder,
    selectAddUrl, 
    disabled, 
    style={}, 
    inputClass, 
    errors, 
    choices, 
    onChange = () => {},
    pk = null,
  }) => {
  const [newCreated, setNewCreated] = useState([])
  const [inputValue, setInputValue] = useState(value);

  const localOnChange = (e) => {
    !value && (value = []);
    e.target.checked ? value.push(e.target.value) : value.splice(value.indexOf(e.target.value), 1)
    setInputValue(value)
    onChange({'name':fieldName, 'value': value.filter(e => e !== ''), 'label': value.length + ' ' + label})
  }
  const finalizeTag = (id, tag, isNew)=> {
    options.push({id:id,label:tag, disabled:false})
    setNewCreated( newCreated =>[...newCreated, id])
  }

  const  getButtonActions = useButtonActions()
  const action = getButtonActions(null, {'action_id': selectAddUrl}, 'btn btn-sm ms-1 my-auto rounded ' + AppSettingsVar.button_class, '', true, null, null, null, false, 'pop_over', finalizeTag)


  return ( <div class="d-flex align-item-center checkbox-wrapper ">
            {options?.map( (option) =>
              <label 
              key={pk ? pk + '_' + fieldName + '_' + option.id : fieldName + '_' +  option.id} 
              id={pk ? pk + '_' + fieldName + '_' + option.id : fieldName + '_' +  option.id} 
              tabIndex={0} 
              className={`${fieldName}-existing checkbox-card ${style.class}`}
              >
                <input type="checkbox" name={fieldName} value={option.id} checked={inputValue && inputValue.includes(option.id) || newCreated.includes(option.id)} onChange={localOnChange} disabled={disabled}/>
                {option.label }
              </label>
            )}
            {(!options || options?.length === 0) && <p>{i18n.t('No {{label}} available to choose', {label: label} )}</p>}
            {action}

          </div>
  )
}

export default CheckboxCards
